<template>
  <div class="patient-form-container" :class="modalTheme">
    <!-- Add the load button at the top -->
    <!-- <div class="form-actions-top">
      <button :disabled="!patientStore.currentPatient.lastName" type="button" class="btn btn-info" @click="loadFromPatientStore">Load Current Patient from Store</button>
      <button type="button" class="btn btn-secondary" @click="loadFromProps">Load from Props</button>
      <button type="button" class="btn btn-secondary" @click="loadSampleData">Load Sample Data</button>
      <span v-if="patientStore.currentPatient.lastName" class="current-patient-info"> Current: {{ patientStore.currentPatient.firstName }} {{ patientStore.currentPatient.lastName }} </span>
      <span v-else class="no-patient-info"> No current patient selected </span>
    </div> -->
    <div>
      <b-tabs content-class="mt-3" justified>
        <b-tab title="Policy Information" active>
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
            <div class="form-section full-width" :class="userStore.borderClass">
              <h3 style="text-align: left">Policy Information</h3>

              <b-form-group label="Insurance Carrier:" label-for="policyCarrier" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="policyCarrier" :class="modalTheme" v-model="form.policyCarrier" size="sm" placeholder="Enter insurance carrier" />
              </b-form-group>

              <b-form-group label="Group Number:" label-for="policyGroupNumber" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="policyGroupNumber" :class="modalTheme" v-model="form.policyGroupNumber" size="sm" placeholder="Enter group number" />
              </b-form-group>

              <b-form-group label="Certificate Number:" label-for="policyCertificateNumber" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="policyCertificateNumber" :class="modalTheme" v-model="form.policyCertificateNumber" size="sm" placeholder="Enter certificate number" />
              </b-form-group>

              <b-form-group label="Plan Type:" label-for="policyPlanType" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-select
                  id="policyPlanType"
                  :class="modalTheme"
                  v-model="form.policyPlanType"
                  size="sm"
                  :options="[
                    { value: 0, text: 'Select Plan Type' },
                    { value: 1, text: 'HMO' },
                    { value: 2, text: 'PPO' },
                    { value: 3, text: 'EPO' },
                    { value: 4, text: 'POS' },
                    { value: 5, text: 'Medicare' },
                    { value: 6, text: 'Medicaid' },
                    { value: 7, text: 'Other' },
                  ]"
                />
              </b-form-group>

              <b-form-group label="Enrollment Date:" label-for="policyEnrollmentDate" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="policyEnrollmentDate" :class="modalTheme" v-model="form.policyEnrollmentDate" type="date" size="sm" />
              </b-form-group>

              <b-form-group label="Termination Date:" label-for="policyTermniationDate" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="policyTermniationDate" :class="modalTheme" v-model="form.policyTermniationDate" type="date" size="sm" />
              </b-form-group>

              <b-form-group label="Payment Source:" label-for="policyPaymentSource" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-select
                  id="policyPaymentSource"
                  :class="modalTheme"
                  v-model="form.policyPaymentSource"
                  size="sm"
                  :options="[
                    { value: 0, text: 'Select Payment Source' },
                    { value: 1, text: 'Employer' },
                    { value: 2, text: 'Individual' },
                    { value: 3, text: 'Government' },
                    { value: 4, text: 'Other' },
                  ]"
                />
              </b-form-group>

              <b-form-group label="Formulary:" label-for="policyFormulary" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="policyFormulary" :class="modalTheme" v-model="form.policyFormulary" size="sm" placeholder="Enter formulary information" />
              </b-form-group>

              <b-form-group label="Policy Notes:" label-for="policyNotes" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-textarea id="policyNotes" :class="modalTheme" v-model="form.policyNotes" size="sm" placeholder="Enter policy notes" rows="3" max-rows="5" />
              </b-form-group>
            </div>

            <div class="form-actions">
              <b-button type="reset" variant="secondary">Reset</b-button>
              <b-button type="submit" variant="primary">Save Policy</b-button>
            </div>
          </b-form>
        </b-tab>
        <b-tab title="Subscriber Information">
          <h5 style="background-color: red; color: yellow">NO SCREENSHOT cloned from POLICY !</h5>
          <h5 style="background-color: red; color: yellow">* check POST model (both forms are incl)</h5>
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
            <div class="form-section full-width" :class="userStore.borderClass">
              <h3 style="text-align: left">Subscriber Information</h3>

              <b-form-group label="Insurance Carrier:" label-for="subscriberCarrier" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="subscriberCarrier" :class="modalTheme" v-model="form.subscriberCarrier" size="sm" placeholder="Enter insurance carrier" />
              </b-form-group>

              <b-form-group label="Group Number:" label-for="subscriberGroupNumber" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="subscriberGroupNumber" :class="modalTheme" v-model="form.subscriberGroupNumber" size="sm" placeholder="Enter group number" />
              </b-form-group>

              <b-form-group label="Certificate Number:" label-for="subscriberCertificateNumber" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="subscriberCertificateNumber" :class="modalTheme" v-model="form.subscriberCertificateNumber" size="sm" placeholder="Enter certificate number" />
              </b-form-group>

              <b-form-group label="Plan Type:" label-for="subscriberPlanType" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-select
                  id="subscriberPlanType"
                  :class="modalTheme"
                  v-model="form.subscriberPlanType"
                  size="sm"
                  :options="[
                    { value: 0, text: 'Select Plan Type' },
                    { value: 1, text: 'HMO' },
                    { value: 2, text: 'PPO' },
                    { value: 3, text: 'EPO' },
                    { value: 4, text: 'POS' },
                    { value: 5, text: 'Medicare' },
                    { value: 6, text: 'Medicaid' },
                    { value: 7, text: 'Other' },
                  ]"
                />
              </b-form-group>

              <b-form-group label="Enrollment Date:" label-for="subscriberEnrollmentDate" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="subscriberEnrollmentDate" :class="modalTheme" v-model="form.subscriberEnrollmentDate" type="date" size="sm" />
              </b-form-group>

              <b-form-group label="Termination Date:" label-for="subscriberTermniationDate" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="subscriberTermniationDate" :class="modalTheme" v-model="form.subscriberTermniationDate" type="date" size="sm" />
              </b-form-group>

              <b-form-group label="Payment Source:" label-for="subscriberPaymentSource" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-select
                  id="subscriberPaymentSource"
                  :class="modalTheme"
                  v-model="form.subscriberPaymentSource"
                  size="sm"
                  :options="[
                    { value: 0, text: 'Select Payment Source' },
                    { value: 1, text: 'Employer' },
                    { value: 2, text: 'Individual' },
                    { value: 3, text: 'Government' },
                    { value: 4, text: 'Other' },
                  ]"
                />
              </b-form-group>

              <b-form-group label="Formulary:" label-for="subscriberFormulary" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-input id="subscriberFormulary" :class="modalTheme" v-model="form.subscriberFormulary" size="sm" placeholder="Enter formulary information" />
              </b-form-group>

              <b-form-group label="Subscriber Notes:" label-for="subscriberNotes" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
                <b-form-textarea id="subscriberNotes" :class="modalTheme" v-model="form.subscriberNotes" size="sm" placeholder="Enter subscriber notes" rows="3" max-rows="5" />
              </b-form-group>
            </div>

            <div class="form-actions">
              <b-button type="reset" variant="secondary">Reset</b-button>
              <b-button type="submit" variant="primary">Save Subscriber</b-button>
            </div>
          </b-form>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import moment from "moment";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STORE
import { usePatientStore } from "@/stores/patientStore";
import { searchForPatient } from "@/api/patientApi";
const patientStore = usePatientStore();

const modalTheme = computed(() => userStore.bModalTheme);

// Emits
const emit = defineEmits(["save-patient", "reset-form"]);

// & PROPS
const props = defineProps({
  testPatient: {
    Type: Object,
    Default: () => {},
  },
});

// Create form factory function
function createForm() {
  return {
    policyCarrier: "",
    policyGroupNumber: "",
    policyCertificateNumber: "",
    policyEnrollmentDate: "",
    policyTermniationDate: "",
    policyPlanType: 0,
    policyPaymentSource: 0,
    policyFormulary: "",
    policyNotes: "",
    subscriberCarrier: "",
    subscriberGroupNumber: "",
    subscriberCertificateNumber: "",
    subscriberEnrollmentDate: "",
    subscriberTermniationDate: "",
    subscriberPlanType: 0,
    subscriberPaymentSource: 0,
    subscriberFormulary: "",
    subscriberNotes: "",
  };
}

// Form state
const form = ref(createForm());
const AreIdsShown = ref(true);

// Form validation
const isFormValid = () => {
  if (!form.value.firstName.trim()) {
    alert("First name is required");
    return false;
  }
  if (!form.value.lastName.trim()) {
    alert("Last name is required");
    return false;
  }
  if (!form.value.patientID.trim()) {
    alert("Patient ID is required");
    return false;
  }
  return true;
};

// Form handlers
function onSubmit() {
  if (!isFormValid()) {
    return;
  }

  const payload = {
    ...form.value,
    // Convert date strings to proper formats if needed
    chartReviewDate: form.value.chartReviewDate ? new Date(form.value.chartReviewDate).toISOString() : null,
    startDate: form.value.startDate ? new Date(form.value.startDate).toISOString() : null,
    endDate: form.value.endDate ? new Date(form.value.endDate).toISOString() : null,
    nextAppointment: form.value.nextAppointment ? new Date(form.value.nextAppointment).toISOString() : null,
    serviceDate: form.value.serviceDate ? moment(form.value.serviceDate).format("MM/DD/YYYY") : "",
  };

  emit("save-patient", payload);
  console.log("Saving patient:", payload);
}

function onReset() {
  form.value = createForm();
  emit("reset-form");
}

// Add method to handle emergency contact selection
function selectEmergencyContact() {
  // Add your selection logic here
  console.log("Select emergency contact Clicked        >>>>>>>>>  DO SOMETHING");
}
function editEmergencyContact() {
  // Add your selection logic here
  console.log("EDIT emergency contact clicked         >>>>>>>>>  DO SOMETHING");
}
// Load initial data (example with the provided values)
function loadSampleData() {
  form.value = {
    personID: 14526,
    firstName: "Sample",
    middleName: "M",
    lastName: "DATA",
    dateOfBirth: "1971-09-16",
    patientID: "2405061",
    memberID: "N/A",
    insuranceCarrier: "UNKNOWN",
    dob: "19710916",
    gender: "F",
    providerName: "Grizzle, Melissa",
    serviceDate: "2022-12-14",
    lastSeenByMe: "Grizzle, Melissa",
    chartReviewDate: moment("0001-01-01T00:00:00Z").isValid() ? moment("0001-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
    chartReviewBy: null,
    chartReviewNeeded: true,
    chartReviewComment: null,
    chartReviewRole: null,
    emrId: null,
    startDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    nextAppointmentWith: "",
    nextAppointmentReason: "",
    nextAppointmentType: "",
    nextAppointmentComment: "",
    patientStatus: true,
    endDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    appointmentLocation: null,
    isScheduled: false,
    nextAppointment: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
  };
}
function loadFromProps() {
  if (props.testPatient && typeof props.testPatient === "object") {
    form.value = {
      ...createForm(),
      ...props.testPatient,
      chartReviewDate: props.testPatient.chartReviewDate ? moment(props.testPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: props.testPatient.startDate ? moment(props.testPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: props.testPatient.endDate ? moment(props.testPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: props.testPatient.nextAppointment ? moment(props.testPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
  }
}

// New method to bind from store object to form
function loadFromPatientStore() {
  const currentPatient = patientStore.currentPatient;
  if (currentPatient && typeof currentPatient === "object") {
    form.value = {
      ...createForm(),
      ...currentPatient,
      // Handle date conversions
      dateOfBirth: currentPatient.dateOfBirth ? moment(currentPatient.dateOfBirth).format("YYYY-MM-DD") : "",
      serviceDate: currentPatient.serviceDate ? moment(currentPatient.serviceDate).format("YYYY-MM-DD") : "",
      chartReviewDate: currentPatient.chartReviewDate ? moment(currentPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: currentPatient.startDate ? moment(currentPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: currentPatient.endDate ? moment(currentPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: currentPatient.nextAppointment ? moment(currentPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
    console.log("Loaded patient from store:", currentPatient);
  } else {
    console.warn("No current patient found in store");
    alert("No current patient available in store");
  }
}

onMounted(() => {
  // console.log("onMounted() : Patient Form >>>>");
  // console.log("props : testPatient ");
  // console.log(props.testPatient);
  // loadSampleData();
  // loadFromProps();
  // loadFromPatientStore();
});
</script>

<style scoped>
.patient-form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  height: 65vh;
  overflow: hidden;
  overflow-y: auto;
}

.form-section {
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.form-section h3 {
  margin-bottom: 15px;
  font-size: 1.2em;
  border-bottom: 2px solid #007bff;
  padding-bottom: 5px;
  text-align: center;
}

.form-section.full-width {
  flex: 0 0 100%;
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 0;
  border-top: 1px solid #dee2e6;
  margin-top: 20px;
}

hr {
  border: none;
  height: 1px;
  background-color: #0d85fd;
  margin: 20px 0;
}

/* Bootstrap Vue form group label alignment */
.b-form-group .col-form-label {
  font-size: 15px !important;
  font-weight: 600;
  text-align: right !important;
  justify-content: flex-end !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  white-space: nowrap;
}

/* Remove Bootstrap Vue form group internal spacing */
.b-form-group {
  margin-bottom: 0.5rem !important;
}

.b-form-group .row {
  margin: 0 !important;
}

.b-form-group .row > [class*="col"] {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/* 10px gap between label and input columns */
.form-section .b-form-group .row > [class*="col"]:first-child {
  padding-right: 10px !important;
  padding-left: 0 !important;
}

.form-section .b-form-group .row > [class*="col"]:not(:first-child) {
  padding-left: 0 !important;
  padding-right: 5px !important;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .form-group {
    min-width: unset;
  }
}
</style>
